import { createFeatureSelector, createSelector } from '@ngrx/store';

import {
  connectTokenFeatureKey,
  ConnectTokenState,
} from './connect-token.reducer';

/**
 * Selects connect token state
 */
export const selectConnectTokenState = createFeatureSelector<ConnectTokenState>(
  connectTokenFeatureKey,
);

/**
 * Selects connect token
 */
export const selectConnectToken = createSelector(
  selectConnectTokenState,
  (state) => state.token,
);
